import type { JumpPointConfig } from '~/config'

/**
 * The 1-based analytics ordinal of a jump point (`game_pass_boost_N`).
 * N is the point's position in the FULL config list sorted by
 * required_score — never the visible list — so the ordinal is a stable
 * product identity even when earlier points are hidden by the user's
 * progress or a missing server product (see GLOSSARY.md, decided
 * 2026-07-29).
 */
export function getBoostOrdinal(
  jumpPoints: JumpPointConfig[] | undefined,
  requiredScore: number,
): number {
  const sortedScores = (jumpPoints ?? [])
    .map((jumpPoint) => jumpPoint.required_score)
    .sort((a, b) => a - b)
  return sortedScores.indexOf(requiredScore) + 1
}
